import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core'
import { map } from 'rxjs/operators'
import { ContactBoxNavigationData } from './contact-box-navigation.module'
import { combineLatest } from 'rxjs'
import { ComponentState } from '../../types'
import { CmsBaseComponent } from '../../shared/cms-base-component/cms-base.component'
import { ContactBoxService } from '../contact-box.service'

@Component({
  selector: 'mb-contact-box-navigation',
  templateUrl: './contact-box-navigation.component.html',
  styleUrls: ['./contact-box-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactBoxNavigationComponent extends CmsBaseComponent<ContactBoxNavigationData> implements OnInit {

  @Output() closeContact = new EventEmitter<Event>()

  contactData$ = this.contactBoxService.getContactData()

  state$ = combineLatest([this.baseState$, this.contactData$]).pipe(
    map(([baseState, contactData]) => ({
      ...baseState,
      contactData,
    } as ContactBoxNavigationState))
  )

  constructor (private contactBoxService: ContactBoxService) {
    super()
  }

  ngOnInit () {
    super.ngOnInit()
  }
}

export interface ContactBoxNavigationState extends ComponentState<ContactBoxNavigationData> {
  contactData: ContactBoxNavigationData | undefined;
}
